import { templateTransitVisaData } from "../data/order/customerTransitVisaTable";
import fetchServer from "./fetchServer";

export async function getVisaRequirementsApi(queryObj) {
  var result = { return: 0, msg: "Error", data: {} };

  const queryString = new URLSearchParams(queryObj).toString();

  await fetchServer({
    method: "GET",
    url: `/product/v1/transitVisaRequirement?${queryString}`,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200) {
          result = { return: 1, msg: "Successful", data: res.data?.data || [] };
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
    });

  return result;
}

export async function getVisaRequirements({ setLoading, pagination }) {
  setLoading?.(true);
  const res = await getVisaRequirementsApi({
    limit: pagination?.perPage,
    offset: pagination?.perPage * (pagination?.page - 1),
  }).finally(() => setLoading?.(false));
  if (res?.return) {
    const data = res?.data;
    return [
      data?.meta?.total,
      (data?.data || [])?.map((item) => templateTransitVisaData(item)),
      data?.data,
    ];
  }
  return [0, [], []];
}

export async function createVisaRequirementsApi(data) {
  var result = { return: 0, msg: "Error", data: {} };

  await fetchServer({
    method: "POST",
    url: `/product/v1/transitVisaRequirement`,
    data,
  })
    .then((res) => {
      if (res) {
        if (res.status === 201) {
          result = { return: 1, msg: "Successful", data: res.data?.data || [] };
        } else {
          if (res?.data?.code === 10 && typeof res?.data?.detail === "string") {
            result = { return: 0, msg: res?.data?.detail, data: {} };
          }
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
    });

  return result;
}

export async function bulkCreateVisaRequirementsApi(data) {
  var result = { return: 0, msg: "Error", data: {} };

  await fetchServer({
    method: "POST",
    url: `/product/v1/transitVisaRequirement/bulk`,
    data,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200) {
          result = { return: 1, msg: "Successful", data: res.data?.data || [] };
        } else {
          if (res?.data?.code === 10 && typeof res?.data?.detail === "string") {
            result = { return: 0, msg: res?.data?.detail, data: {} };
          }
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
    });

  return result;
}

export async function updateVisaRequirementsApi(id, data) {
  var result = { return: 0, msg: "Error", data: {} };

  await fetchServer({
    method: "PATCH",
    url: `/product/v1/transitVisaRequirement/${id}`,
    data,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200) {
          result = { return: 1, msg: "Successful", data: res.data?.data || [] };
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
    });

  return result;
}

export async function activateVisaRequirementsApi(id, data) {
  var result = { return: 0, msg: "Error", data: {} };

  await fetchServer({
    method: "PATCH",
    url: `/product/v1/transitVisaRequirement/${id}/activate`,
    data,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200) {
          result = { return: 1, msg: "Successful", data: res.data?.data || [] };
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
    });

  return result;
}

export async function deactivateVisaRequirementsApi(id, data) {
  var result = { return: 0, msg: "Error", data: {} };

  await fetchServer({
    method: "PATCH",
    url: `/product/v1/transitVisaRequirement/${id}/deactivate`,
    data,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200) {
          result = { return: 1, msg: "Successful", data: res.data?.data || [] };
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
    });

  return result;
}

export async function deleteVisaRequirementsApi(id, data) {
  var result = { return: 0, msg: "Error", data: {} };

  await fetchServer({
    method: "DELETE",
    url: `/product/v1/transitVisaRequirement/${id}`,
    data,
  })
    .then((res) => {
      if (res) {
        if (res.status === 200) {
          result = { return: 1, msg: "Successful", data: res.data?.data || [] };
        }
      }
    })
    .catch((err) => {
      console.log("Network Error: ", err);
    });

  return result;
}
